<template>
  <div class="qrcode_box">
    <div class="qrcode_item wechat">
      <qrcode-vue
        v-show="wechatQr" class="qr" :value="wechatQr" level="H"
        :size="88"
      />
      <div class="btn">微信扫码支付</div>
    </div>
    <div class="qrcode_item zfb">
      <qrcode-vue
        v-show="aliQr" class="qr" :value="aliQr" level="H"
        :size="88"
      />
      <div class="btn">支付宝扫码支付</div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'BuyQrcode',

  components: { QrcodeVue },

  props: {
    wechatQr: {
      type: String,
      default: ''
    },

    aliQr: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.qrcode_box { text-align: center;
    .qrcode_item { display: inline-block; }
    .wechat {  margin-right: 80px; }
    .qr { box-sizing: border-box; width: 100px; height: 100px; padding: 4px; margin-bottom: 8px; background-repeat: no-repeat; background-position: center center; background-size: 88px 88px; border: 2px solid #68c978; border-radius: 4px; }
    .btn { width: 100px; height: 28px; font-size: 12px; font-weight: 500; line-height: 28px; color: #fff; background-color: #68c978; border-radius: 4px; }
    .zfb {
      .qr { border-color: #00a0e9; }
      .btn { background-color: #00a0e9; }
    }
  }
</style>
